import { useEffect } from 'react';
import { RefundRocket } from '../../tools/refundrocket';

/**
 * Route wrapper for RefundRocket. Sets SEO meta on mount and renders the
 * wizard inside the shared Header/Footer shell (added by App.tsx).
 */
export function RefundRocketRoute() {
  useEffect(() => {
    document.title = 'RefundRocket - Estimate your US tax refund | PocketLedger';
    const meta =
      document.querySelector('meta[name="description"]') ??
      Object.assign(document.createElement('meta'), {
        name: 'description',
      });
    meta.setAttribute(
      'content',
      'Estimate your 2026 US federal tax refund in 5 steps. Free, private, 100% client-side.',
    );
    if (!meta.isConnected) {
      document.head.appendChild(meta);
    }
  }, []);

  return <RefundRocket />;
}

export default RefundRocketRoute;